var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashCanSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.416 5.00008H21.8327V7.16675H19.666V21.2501C19.666 21.5374 19.5519 21.813 19.3487 22.0161C19.1456 22.2193 18.87 22.3334 18.5827 22.3334H3.41602C3.1287 22.3334 2.85315 22.2193 2.64998 22.0161C2.44682 21.813 2.33268 21.5374 2.33268 21.2501V7.16675H0.166016V5.00008H5.58268V1.75008C5.58268 1.46276 5.69682 1.18721 5.89998 0.984049C6.10315 0.780885 6.3787 0.666748 6.66602 0.666748H15.3327C15.62 0.666748 15.8956 0.780885 16.0987 0.984049C16.3019 1.18721 16.416 1.46276 16.416 1.75008V5.00008ZM17.4993 7.16675H4.49935V20.1667H17.4993V7.16675ZM7.74935 10.4167H9.91602V16.9167H7.74935V10.4167ZM12.0827 10.4167H14.2493V16.9167H12.0827V10.4167ZM7.74935 2.83341V5.00008H14.2493V2.83341H7.74935Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCanSm);
export default __webpack_public_path__ + "static/media/Trash-Can-sm.959798cf820839f92f9e3fbfa9c365d5.svg";
export { ForwardRef as ReactComponent };